import CookieDeclaration from './cookieDeclaration';

export default CookieDeclaration;
